import { TableHead, SearchData, InputBoX } from "../../../../common/dataClass/Default"

/**采购计划单搜索数据 */
class PlanSearchData extends SearchData{
  constructor() {
    super()
    /**创建日期 */
    this.createdDate = ''
    /**交货日期 */
    this.deliveryDate = ''
    /**采购状态 */
    this.purchaseStatus = ''
    /**采购计划分类 */
    this.purchaseSort = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

class PurchaseTableHead extends TableHead{
  constructor(name, prop, width, obj) {
    super(name, prop, width, obj)
  }
}

/**采购方信息 */
class PurchaseInfo{
  constructor() {
    /**公司名称 */
    this.companyName = ''
    /**采购联系人 */
    this.contactName = ''
    /**采购联系电话 */
    this.contactNum = ''
    /**采购方地址 */
    this.province = ''
    this.city = ''
    this.county = ''
    this.location = ''
    /**备注 */
    this.remark = ''
  }
}

class PurchaseInputBox extends InputBoX{
  constructor(type, name, data, obj = { isRequired: false }){
    super(type, name, data, obj)
    /**是否必填 */
    this.isRequired = obj.isRequired == undefined ? true : obj.isRequired
  }
}

class PurchaseNewModule{
  /**采购计划单表头 */
  static NEWPLANTABLEHEAD(){
    let arr = [
      new PurchaseTableHead('采购计划单号', 'img', '200'),
      new PurchaseTableHead('采购计划分类', 'getCostOfCommodityInvestmentByTable', '200'),
      new PurchaseTableHead('FBA发补货计划单号<br>或产品储备计划单号', 'getNetProfitOfGoodsByTable', '200'),
      new PurchaseTableHead('要求交货日期', 'stockPrice', '100'),
      new PurchaseTableHead('供应商数量', 'getSavePriceByTable', '100'),
      new PurchaseTableHead('Asin/型号数量', 'getCostSummaryByTable', '100'),
      new PurchaseTableHead('总箱数', 'disposalNum', '100'),
      new PurchaseTableHead('总重量<br>(kg)', 'getShowNumAndActualNumByTable', '80'),
      new PurchaseTableHead('总体积<br>(M³)', 'stockPrice', '80'),
      new PurchaseTableHead('货件追踪单号<br>(Amazon ref.ID)', 'disposalNum', '120'),
      new PurchaseTableHead('FBA编号<br>(FBA ID)', 'getCostSummaryByTable', '100'),
      new PurchaseTableHead('亚马逊<br>仓库代码', 'disposalNum', '100'),
      new PurchaseTableHead('操作状态', 'getShowNumAndActualNumByTable', '100'),
      new PurchaseTableHead('采购计划单<br>创建日期', 'stockPrice', '100'),
      new PurchaseTableHead('采购计划单详情', 'disposalNum', '150'),
    ]
    return arr
  }
  /**待补充采购计划单表头 */
  static NEWREPLENISHTABLEHEAD(){
    let arr = [
      new PurchaseTableHead('采购单号', 'img', '200'),
      new PurchaseTableHead('不同采购单<br>的关联数量', 'getCostOfCommodityInvestmentByTable', '200'),
      new PurchaseTableHead('供应商名称', 'getNetProfitOfGoodsByTable', '200'),
      new PurchaseTableHead('Asin数量', 'stockPrice', '100'),
      new PurchaseTableHead('总箱数', 'getSavePriceByTable', '100'),
      new PurchaseTableHead('总重量<br>(kg)', 'getShowNumAndActualNumByTable', '80'),
      new PurchaseTableHead('总体积<br>(M³)', 'stockPrice', '80'),
      new PurchaseTableHead('总采购额<br>(¥)', 'getCostSummaryByTable', '100'),
      new PurchaseTableHead('前款支付金额<br>尾款支付金额', 'disposalNum', '100'),
      new PurchaseTableHead('前款支付日期<br>尾款支付日期', 'disposalNum', '120'),
      new PurchaseTableHead('要求交货日期<br>实际交货日期', 'getCostSummaryByTable', '100'),
      new PurchaseTableHead('采购合同<br>签定状况', 'disposalNum', '100'),
      new PurchaseTableHead('采购货物<br>送仓地址', 'getShowNumAndActualNumByTable', '100'),
      new PurchaseTableHead('仓库联络人<br>仓库联系电话', 'stockPrice', '100'),
      new PurchaseTableHead('采购信息<br>补充状况', 'stockPrice', '100'),
      new PurchaseTableHead('创建日期', 'disposalNum', '150'),
      new PurchaseTableHead('操作', 'disposalNum', '150'),
    ]
    return arr
  }
  /**待补充采购计划单表头 */
  static NEWORDERTABLEHEAD(){
    let arr = [
      new PurchaseTableHead('采购单号', 'img', '200'),
      new PurchaseTableHead('不同采购单<br>的关联数量', 'getCostOfCommodityInvestmentByTable', '200'),
      new PurchaseTableHead('供应商名称', 'getNetProfitOfGoodsByTable', '200'),
      new PurchaseTableHead('Asin数量', 'stockPrice', '100'),
      new PurchaseTableHead('总箱数', 'getSavePriceByTable', '100'),
      new PurchaseTableHead('总重量<br>(kg)', 'getShowNumAndActualNumByTable', '80'),
      new PurchaseTableHead('总体积<br>(M³)', 'stockPrice', '80'),
      new PurchaseTableHead('总采购额<br>(¥)', 'getCostSummaryByTable', '100'),
      new PurchaseTableHead('前款支付金额<br>尾款支付金额', 'disposalNum', '100'),
      new PurchaseTableHead('前款支付日期<br>尾款支付日期', 'disposalNum', '120'),
      new PurchaseTableHead('要求交货日期<br>实际交货日期', 'getCostSummaryByTable', '100'),
      new PurchaseTableHead('采购合同<br>签定状况', 'disposalNum', '100'),
      new PurchaseTableHead('采购货物<br>送仓地址', 'getShowNumAndActualNumByTable', '100'),
      new PurchaseTableHead('仓库联络人<br>仓库联系电话', 'stockPrice', '100'),
      new PurchaseTableHead('采购信息<br>补充状况', 'stockPrice', '100'),
      new PurchaseTableHead('支付状况', 'disposalNum', '150'),
      new PurchaseTableHead('创建日期', 'disposalNum', '150'),
      new PurchaseTableHead('操作', 'disposalNum', '150'),
    ]
    return arr
  }
  /**采购方信息输入框 */
  static NEWINFOINPUTBOX(){
    let obj = {
      companyName: new PurchaseInputBox('text', '公司名称', 'companyName', { isRequired: false, pla: '备注：无公司可以不填' }),
      contactName: new PurchaseInputBox('text', '采购联系人', 'contactName', { isRequired: true, pla: '' }),
      contactNum: new PurchaseInputBox('number', '采购联系电话', 'contactNum', { isRequired: true, pla: '' }),
      location: new PurchaseInputBox('location', '采购方地址', 'location', { isRequired: false, pla: '' }),
      remark: new PurchaseInputBox('textarea', '备注', 'remark', { isRequired: false, pla: '' }),
    }
    return obj
  }
  /**创建进度条数据 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '在"销售"目录点击"新建FBA发补货计划或产品储备计划"',
      '点击"生成采购单"按钮,在弹窗中选择"子采购计划单"进行"独立或合并生成采购单"',
      '在"待补充采购单"目录点击"补充"按钮输入补充信息',
      '生成"采购单"'
    ]
    return arr
  }
}

export{ PlanSearchData, PurchaseNewModule, PurchaseInfo }
